import client from "directus/src/client";
import {
  customEndpoint,
  getItemsFromCollection,
} from "directus/src/operations";

export async function fetchProjectMeta({ project_id }) {
  try {
    const query = {
      fields: ["id", "logo", "name", "status", "coordinator", "sales_coordinator", "bookmark_folder", { tags: ["id", { tag: ["id", "label"] }] }],
      filter: {
        project_id: { _eq: project_id },
      },
    };
    const response = await getItemsFromCollection("projects", query);
    return response[0];
  } catch (error) {
    console.error(error);
    throw error;
  }
}
export async function fetchProjectJobCount({ project_id }) {
  try {
    const query = {
      filter: {
        project: { _eq: project_id },
        status: { _eq: "in_progress" },
      },
      aggregate: {
        countDistinct: ["id"],
      },
    };
    const response = await getItemsFromCollection("jobs", query);
    return response?.[0]?.countDistinct.id;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
export async function fetchProjectBillableCount({ project_id }) {
  try {
    const query = {
      filter: {
        job: { project: { _eq: project_id } },
        status: { _nin: ["collected", "cancelled", "archived"] },
      },
      aggregate: {
        countDistinct: ["id"],
      },
    };
    const response = await getItemsFromCollection("billables", query);
    return response?.[0]?.countDistinct.id;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
export async function fetchProjectMilestoneCount({ project_id }) {
  try {
    const query = {
      filter: {
        job: { project: { _eq: project_id } },
        status: { _eq: "in_progress" },
      },
      aggregate: {
        countDistinct: ["id"],
      },
    };
    const response = await getItemsFromCollection("milestones", query);
    return response?.[0]?.countDistinct.id;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetch({ project_id }) {
  try {
    const query = {
      filter: {
        job: { project: { project_id: { _eq: project_id } } },
        status: { _eq: "in_progress" },
      },
      aggregate: {
        countDistinct: ["id"],
      },
    };
    const response = await getItemsFromCollection("milestones", query);
    return response?.[0]?.countDistinct.id;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchProjectRevenueCalculation({ projectId, startDate, endDate }) {
  try {
    const params = new URLSearchParams();
    if (projectId) params.append("projectId", projectId);
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const response = await client.request(
      customEndpoint({
        path: `/revenue-calculation/project-dashboard?${params.toString()}`,
        method: "GET",
      })
    );
    return response?.data ?? response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}